<template>
<div>
    <annual-leave-right-list></annual-leave-right-list>
</div>
</template>

<script>
export default {}
</script>
